import { Link } from 'react-router-dom';
import './NavbarV2.css';
import { FaBoxOpen, FaCartArrowDown, FaChartLine, FaClipboardCheck, FaFolderOpen, FaHome, FaUser, FaUserCog, FaUserFriends, FaUserPlus } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { formatMoney } from '../../utils/formatMoney';

const NavbarV2 = () => {
    const cart = useSelector((state) => state.cartReducer.items);
    const [total, setTotal] = useState(0);
    const isAdmin = localStorage.getItem('admin') === "true";
    const isLoggedIn = localStorage.getItem('account') !== null;

    useEffect(() => {
        let sum = 0;
        cart.forEach(item => { sum += item.price * item.amount; });
        setTotal(sum);
    }, [cart]);

    return (
        <nav className="navv2">
            <div className="navv2-left">
                <Link to="/" className="navv2-brand">
                    <div className="navv2-link">
                        <FaHome color="#FFF" size={18} />
                        <span>Sicily</span>
                    </div>
                </Link>
            </div>
            <div className="navv2-right">
                {isLoggedIn ? (
                    <>
                        {isAdmin && (
                            <Link to="/users" className="navv2-admin">
                                <div className="navv2-link">
                                    <FaUserFriends size={16} />
                                    <span>Users</span>
                                </div>
                            </Link>
                        )}
                        {isAdmin && (
                            <Link to="/admin" className="navv2-admin">
                                <div className="navv2-link">
                                    <FaFolderOpen size={16} />
                                    <span>Admin</span>
                                </div>
                            </Link>
                        )}
                        {isAdmin && (
                            <Link to="/admin/revenue" className="navv2-admin">
                                <div className="navv2-link">
                                    <FaChartLine size={16} />
                                    <span>Revenue</span>
                                </div>
                            </Link>
                        )}
                        <Link to="/orders" className={isAdmin ? 'navv2-admin' : undefined}>
                            <div className="navv2-link">
                                <FaBoxOpen size={16} />
                                <span>Orders</span>
                            </div>
                        </Link>
                        {isAdmin && (
                            <Link to="/packing" className="navv2-admin">
                                <div className="navv2-link">
                                    <FaClipboardCheck size={16} />
                                    <span>Packing</span>
                                </div>
                            </Link>
                        )}
                        <Link to="/invoices" className={isAdmin ? 'navv2-admin' : undefined}>
                            <div className="navv2-link">
                                <FaBoxOpen size={16} />
                                <span>Invoices</span>
                            </div>
                        </Link>
                        {isAdmin && (
                            <Link to="/creditnotes" className="navv2-admin">
                                <div className="navv2-link">
                                    <FaBoxOpen size={16} />
                                    <span>Credit Notes</span>
                                </div>
                            </Link>
                        )}
                        {isAdmin && (
                            <Link to="/reports" className="navv2-admin">
                                <div className="navv2-link">
                                    <FaBoxOpen size={16} />
                                    <span>Reports</span>
                                </div>
                            </Link>
                        )}
                        <Link to="/account">
                            <div className="navv2-link">
                                <FaUserCog size={16} />
                                <span>Account</span>
                            </div>
                        </Link>
                        <Link to="/cart">
                            <div className="navv2-link navv2-cart">
                                <FaCartArrowDown size={16} />
                                <span>€{formatMoney(total)}</span>
                            </div>
                        </Link>
                    </>
                ) : (
                    <>
                        <Link to="/login">
                            <div className="navv2-link">
                                <FaUser size={16} />
                                <span>Login</span>
                            </div>
                        </Link>
                        <Link to="/register">
                            <div className="navv2-link">
                                <FaUserPlus size={16} />
                                <span>Register</span>
                            </div>
                        </Link>
                        <Link to="/cart">
                            <div className="navv2-link navv2-cart">
                                <FaCartArrowDown size={16} />
                                <span>€{formatMoney(total)}</span>
                            </div>
                        </Link>
                    </>
                )}
            </div>
        </nav>
    );
};

export default NavbarV2;
